import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axiosInstance from '../api/axiosConfig';
import { FiUser, FiLock, FiLogIn } from 'react-icons/fi';
import './Login.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await axiosInstance.post(
                '/api/auth/login',
                {
                    username,
                    password
                }
            );

            if (response.data.success) {
                login(response.data.user, response.data.token);
                
                // Redirect to visitor page if username is "visitor"
                if (username.toLowerCase() === 'visitor') {
                    navigate('/visitor');
                } else {
                    navigate('/purpose-selection');
                }
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            {/* Left panel — brand */}
            <div className="login-brand-panel">
                <div className="login-brand-inner">
                    <img src="/logo.png" alt="Logo" className="login-brand-logo" />
                    <h2 className="login-brand-name">PrimeOffice Manager</h2>
                    <p className="login-brand-tagline">Smart. Simple. Seamless.</p>
                </div>
            </div>

            {/* Right panel — form */}
            <div className="login-form-panel">
                <div className="login-card fade-in">
                    <div className="login-header">
                        <h1>Sign in</h1>
                        <p>Enter your credentials to access your workspace</p>
                    </div>

                    <form onSubmit={handleSubmit}>
                        {error && (
                            <div className="alert alert-error">
                                {error}
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="username" className="form-label">
                                <FiUser size={14} /> Username
                            </label>
                            <input
                                type="text"
                                id="username"
                                className="form-input"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Enter your username"
                                autoComplete="username"
                                required
                                autoFocus
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password" className="form-label">
                                <FiLock size={14} /> Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                className="form-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                autoComplete="current-password"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary btn-lg login-submit-btn"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <div className="spinner spinner-sm" style={{ display: 'inline-block', marginRight: 'var(--spacing-sm)' }}></div>
                                    Signing in...
                                </>
                            ) : (
                                <>
                                    <FiLogIn /> Sign In
                                </>
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
